﻿export class ValidationError {
    constructor(field: string, error: string) {
        this.field = field;
        this.error = error;
    }

    field: string;
    error: string;
}
